import { createContext, type Dispatch, type SetStateAction, use } from 'react';

import { type NotificationDto } from '@/api/generated/models/notification-dto';
import { type NotificationTypeDto } from '@/api/generated/models/notification-type-dto';
import { emptyFunction } from '@/utils/emptyFunction.util';

export type NotificationsContextProps = {
  closeFeedbackDialog: () => void;
  isFeedbackDialogVisible: boolean;
  menuBadges: Record<NotificationTypeDto, NotificationDto[]>;
  openFeedbackDialog: () => void;
  setMenuBadges: Dispatch<SetStateAction<Record<NotificationTypeDto, NotificationDto[]>>>;
  updateNotifications: (notificationsTypes?: NotificationTypeDto[]) => void;
};

export const NotificationsDefaultValues: NotificationsContextProps = {
  closeFeedbackDialog: emptyFunction,
  isFeedbackDialogVisible: false,
  menuBadges: {
    ACCOUNTS_AWAITING_APPROVAL: [],
  },
  openFeedbackDialog: emptyFunction,
  setMenuBadges: emptyFunction,
  updateNotifications: emptyFunction,
};
export const NotificationsContext = createContext<NotificationsContextProps>(
  NotificationsDefaultValues,
);

export const useNotificationsContext = (): NotificationsContextProps => {
  return use<NotificationsContextProps>(NotificationsContext);
};
